<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon class="mx-2" v-on="on">{{ icon.help }}</v-icon>
    </template>
    <span><slot></slot></span>
  </v-tooltip>
</template>

<script>
import { mdiHelpCircleOutline } from "@mdi/js";
export default {
  data: () => ({
    icon: {
      help: mdiHelpCircleOutline
    }
  })
};
</script>
